export default "__VITE_ASSET__7f6bd89b__"